export default __webpack_public_path__ + "img/0ebeb5c29fd6735417872490e08d342b.png";